import { render } from "./RuiSpinnerWrapper.vue?vue&type=template&id=8d2d34b6&scoped=true"
import script from "./RuiSpinnerWrapper.vue?vue&type=script&lang=ts"
export * from "./RuiSpinnerWrapper.vue?vue&type=script&lang=ts"

import "./RuiSpinnerWrapper.vue?vue&type=style&index=0&id=8d2d34b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d2d34b6"

export default script